export default "__VITE_ASSET__BGaZrZlu__"